import React from 'react';

import { Backdrop, Modal, Fade } from '@material-ui/core';
import { useSelector } from 'react-redux';
import { selectObjectivePromptModal } from 'selectors/objectivePromptModal';
import styled from 'styled-components';
import { CenterFlexCSS } from 'styles/common';

const Container = styled.div`
  height: 100vh;
  width: 100%;
  display: flex;
  ${CenterFlexCSS};
  position: relative;
`;

const ModalContainer = styled.div`
  width: 40rem;
  max-height: 70%;

  border-radius: 4px;

  background-color: white;
  display: flex;
  flex-direction: column;
  justify-content: stretch;
`;

const ContainerWide = styled.div`
  height: 100vh;
  width: 100%;
  display: flex;
  ${CenterFlexCSS};
  position: relative;
`;

const ModalContainerWide = styled.div`
  width: 50%;
  max-width: 720px;
  max-height: 60%;

  border-radius: 4px;

  background-color: white;
  display: flex;
  flex-direction: column;
  justify-content: stretch;
`;

export default function ObjectivePromptModal() {
  const { isOpen, contentComponent, wide } = useSelector(selectObjectivePromptModal);

  return (
    <Modal
      role="objective-prompt-modal"
      id="objective-prompt-modal"
      aria-labelledby="Objective prompt Modal"
      open={isOpen}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
    >
      <>
        {wide && (
          <Fade in={isOpen}>
            <ContainerWide>
              <ModalContainerWide>{contentComponent}</ModalContainerWide>
            </ContainerWide>
          </Fade>
        )}
        {!wide && (
          <Fade in={isOpen}>
            <Container>
              <ModalContainer>{contentComponent}</ModalContainer>
            </Container>
          </Fade>
        )}
      </>
    </Modal>
  );
}
